import { takeLatest, all, fork, call, put } from "redux-saga/effects";
import { SharedLinesTypes } from "../action/index.model";
import SDK, { ExplicitPermissions, ImplicitPermissions } from "../../../sdk";
import {
  setSharedError,
  setInvitationInitiatedResponse,
  updateEmailAlreadyExists,
  setNewInvitationInitiatedResponse,
} from "../action/sharedLinesAction";
import { setAssignedLine } from "app/LineDetails/actions";
import { updateApiCallStatus } from "app/actions";
import { setLineDeleveDetails, updateError } from "app/LineDelve/actions";



export function* SendInvitation(payload: any): any {
  try {
    yield put(
      updateApiCallStatus({
        status: "pending",
        module: SharedLinesTypes.SHARED_LINES_STATUS,
      })
    );
    yield put(
      setInvitationInitiatedResponse({ isAssignee: payload.data?.isAssignee })
    );    
    const lines = yield call(SDK.getLineDelveDetails, payload.data.msisdn);
    let emailExists = checkEmailExists(payload,lines);
    if (emailExists) {
      yield put(updateEmailAlreadyExists(payload.data.MSISDN));
    }
    // if (!payload.data?.isAssignee && lines.explicitPermissions) {
    //   lines?.explicitPermissions?.map((r: ExplicitPermissions) => {
    //     if (
    //       r.granteeEmail.toLocaleLowerCase() ===
    //       payload.data?.granteeEmail.toLocaleLowerCase()
    //     ) {
    //       emailExists = true;
    //     }
    //   });
    //   lines?.implicitPermissions?.map((r: ImplicitPermissions) => {
    //     if (
    //       r.user.IAMEmail.toLocaleLowerCase() ===
    //       payload.data?.granteeEmail.toLocaleLowerCase()
    //     ) {
    //       emailExists = true;
    //     }
    //   });
    //   if (emailExists) {
    //     yield put(updateEmailAlreadyExists(payload.data.MSISDN));
    //   }
    // }

    if (!emailExists) {
      let info = yield call(SDK.getInvitationInfo, payload);
      if (checkStatus(info)) {
        info.isAssignee = payload.data?.isAssign;
        yield put(setNewInvitationInitiatedResponse(info));
        if (checkIsAssigneOrGrantorEmail(info,payload)
          
        ) {
          yield put(setAssignedLine(payload.data.MSISDN));
        }

        if (!payload.data?.isAssig) {
          payload.data.redirectUrl = info?.state;
          const linesData = yield call(
            SDK.getLineDelveDetails,
            payload.data.msisdn
          );
          yield put(
            setLineDeleveDetails({
              res: linesData,
              grantorEmail: payload.data.grantorEmail,
            })
          );
          yield put(updateError(""));
          yield put(
            updateApiCallStatus({
              status: "final",
              module: SharedLinesTypes.SHARED_LINES_STATUS,
            })
          );
          /* const email_payload = {
            msisdn: payload.data.MSISDN,
            granteeEmail: payload.data.granteeEmail,
            grantorEmail: payload.data.grantorEmail,
            ownerFirstName: payload.data.ownerFirstName,
            redirectUrl: payload.data.redirectUrl,
            isRevoke: false,
          }; */
          //yield call(SDK.sendEmail, email_payload, lines);
        }
      } else {
        yield put(
          setInvitationInitiatedResponse({
            isAssignee: payload.data?.isAssign,
            error: "Server Busy",
          })
        );
        yield put(
          updateApiCallStatus({
            status: "error",
            module: SharedLinesTypes.SHARED_LINES_STATUS,
          })
        );
      }

      if (info && info?.language && payload.data?.isAssign) {
        yield put(
          updateApiCallStatus({
            status: "final",
            module: SharedLinesTypes.SHARED_LINES_STATUS,
          })
        );
      }
    }
    yield put(
      updateApiCallStatus({
        status: "final",
        module: SharedLinesTypes.SHARED_LINES_STATUS,
      })
    );
  } catch (error) {
    console.log(error, "error");
    yield put(setSharedError({ error: "error" }));
  }
}

function checkIsAssigneOrGrantorEmail(info:any,payload:any){
//info?.language &&
return info.isAssignee ||
payload.data.grantorEmail === payload.data.granteeEmail
}

function checkStatus(info:any){
  return info &&
  !(info.errors || info.message === "TIMEOUT") &&
  info.status === 200
}

function checkEmailExists(payload:any,lines:any){
  let emailExists=false;
    if (!payload.data?.isAssignee && lines.explicitPermissions) {
      lines?.explicitPermissions?.map((r: ExplicitPermissions) => {
        if (
          r.granteeEmail.toLocaleLowerCase() ===
          payload.data?.granteeEmail.toLocaleLowerCase()
        ) {
          emailExists = true;
        }
      });
      lines?.implicitPermissions?.map((r: ImplicitPermissions) => {
        if (
          r.user.IAMEmail.toLocaleLowerCase() ===
          payload.data?.granteeEmail.toLocaleLowerCase()
        ) {
          emailExists = true;
        }
      });
      
    }
    return emailExists;
}
function* sharedLineIntiated() {
  yield takeLatest(SharedLinesTypes.SEND_INVITATION_INITIATED, SendInvitation);
}

export default function* sharedLineSaga() {
  yield all([fork(sharedLineIntiated)]);
}
